"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = auth;

var _constants = require('redux/constants');

var _constants2 = require('components/Registration/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    preload: false,
    step: _constants2.REGISTRATION_STEP_FORM, // REG_START
    errorsList: '',
    is_send_voice_code: false,
    timerRepeat: 30,
    errorCode: null
};

function auth() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.VoiceCodeConstants.VOICE_CODE_FORM_FAIL:
            return (0, _extends3.default)({}, state, {
                errorsList: action.error.title,
                errorCode: action.error.code,
                is_send_voice_code: false
            });
        case _constants.RegistrationConstants.REGISTRATION_FORM_REQUEST:
            return (0, _extends3.default)({}, state, {
                preload: true,
                errorsList: null,
                errorCode: null
            });
        case _constants.RegistrationConstants.REGISTRATION_FORM_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                step: _constants2.REGISTRATION_STEP_CONFIRMED,
                errorsList: null,
                errorCode: null
            });
            break;
        case _constants.RegistrationConstants.REGISTRATION_FORM_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                errorsList: action.error.title,
                errorCode: action.error.code
            });
            break;

        case _constants.RegistrationConstants.REGISTRATION_CONFIRM_REQUEST:
            return (0, _extends3.default)({}, state, {
                preload: true,
                errorsList: null,
                errorCode: null
            });
            break;

        case _constants.RegistrationConstants.REGISTRATION_CONFIRM_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                step: _constants2.REGISTRATION_STEP_CONFIRMED_SUCCESS,
                errorsList: null,
                errorCode: null
            });
            break;

        case _constants.RegistrationConstants.REGISTRATION_CONFIRM_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                errorsList: action.error.title,
                errorCode: action.error.code
            });
            break;

        case _constants.RegistrationConstants.REGISTRATION_RESET_STEP:
            return (0, _extends3.default)({}, state, {
                preload: false,
                step: _constants2.REGISTRATION_STEP_FORM,
                errorsList: null,
                errorCode: null
            });
            break;

        case _constants.RegistrationConstants.REGISTRATION_VOICE_FORM_REQUEST:
        case _constants.RegistrationConstants.REGISTRATION_VOICE_FORM_FAIL:
        case _constants.RegistrationConstants.REGISTRATION_VOICE_RESET:
            return (0, _extends3.default)({}, state, {
                is_send_voice_code: false
            });
        case _constants.RegistrationConstants.REGISTRATION_VOICE_FORM_SUCCESS:
            return (0, _extends3.default)({}, state, {
                is_send_voice_code: true,
                timerRepeat: action.result.timeRepeat
            });

        case _constants.RegistrationConstants.REGISTRATION_RESET_ERROR:
            return (0, _extends3.default)({}, state, {
                errorsList: '',
                errorCode: null
            });
        default:
            return state;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/registration.js
// module id = 1912
// module chunks = 0